import Base from '@/resources/Base'
export default class Permissions extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.subjects = []
  }

  getPermissions () {
    return this.subjects
  }

  setPermissions (permissions) {
    this.subjects = permissions
  }

  addPermissions (permissions) {
    this.subjects = this.subjects.concat(permissions)
  }

  canRead (permission) {
    return _.some(this.subjects, { key: permission, operation: 'Read' })
  }

  canWrite (permission) {
    return _.some(this.subjects, { key: permission, operation: 'Write' })
  }

  can (action, permission) {
    if (action === 'Read') {
      return this.canRead(permission)
    }
    return this.canWrite(permission)
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/Permissions.js